import { useEffect } from 'react';

import { Post } from '@repo/editor/src/types';

import { usePostsStore } from '../../stores/postsStore';

const usePostUpdate = (id: string, setPost: (post: Post) => void): void => {
  useEffect(
    () =>
      usePostsStore.subscribe((state) => {
        const post = state.posts.find((p: Post) => p.id === id);
        if (post) {
          setPost(post);
        }
      }),
    [id, setPost]
  );
};

export default usePostUpdate;
